import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import ObjectOverride from "components/ObjectOverride";
import {Button, Progress} from "reactstrap";
import {Objects} from "../index";
import UniversalModalOverride from "../UniversalModalOverride";
import APPCONFIG from "../../constants/Config";
import API from "@beardeddevops/react.api"
import {confirmAlert} from "react-confirm-alert";

/**
 *  @property {Accounts_Customizations_Object} state
 *  @property {object} model
 *  @property {Accounts_Customizations_Properties} model.properties
 *  @property {Accounts_Customizations_Is} model.is
 *  @property {Accounts_Customizations_Has} model.has
 */
class AccountCloud extends ObjectOverride {
	static propTypes = {
		...Framework.Components.Object.propTypes,
	};

	constructor(props) {
		super(props, Types.Accounts_Customizations._name);
		this.state = {
			...this.state,
			locations: {}
		};
		this.loadDataUsageByLocation().then();
	}

	/**
	 * @param prevProps
	 * @param {Accounts_Customizations_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if (typeof this.props.updateName === 'function') {
			this.props.updateName(this.state.name);
		}
	}

	pendingComplete = (data) => {
		this.state.account_signature = data.account_signature;
		this.update = 'POST_SIGNATURE';
		this.handleSubmit().then();
		this.setState({signature: true});
	};

	downloadPDFs = async () => {
		let zip_bound_book_queue = new API.BuildClass(Types.Locations_Bound_Books_Queues._name, API.RequestType.CREATE);
		zip_bound_book_queue.object.zip_file = true;
		zip_bound_book_queue.parent = this.props.id ? this.props.id : 0;

		const firstUnarchivedLocation = this.props.rootState.locations.find(location => location.archived === false);
		zip_bound_book_queue.grandparent = firstUnarchivedLocation.binary_id + '-' + firstUnarchivedLocation.pkey;
		zip_bound_book_queue.object.location_binary_id = firstUnarchivedLocation.binary_id;
		zip_bound_book_queue.object.location = firstUnarchivedLocation.pkey;
		let result = await zip_bound_book_queue.submit(null, API.RequestType.CREATE);

		this.props.history.push(`/locations/${firstUnarchivedLocation.binary_id}-${firstUnarchivedLocation.pkey}#downloads`);
	}

	generateAccountPDFs = async () => {
		let pdfModel = new API.BuildClass(Types.Forms_Results._name, 'GET_ALL_ACCOUNT_FORMS_INTO_SERVER');
		let res = await pdfModel.submit(this, 'GET_ALL_ACCOUNT_FORMS_INTO_SERVER');
	}

	loadDataUsageByLocation = async () => {
		let dulModel = new API.BuildClass(Types.Filesizes._name, 'GET_LOCATION_BREAKDOWN');
		let result = await dulModel.submit(null, 'GET_LOCATION_BREAKDOWN');
		this.setState({locations: result})
	}

	convertByteSize = (byteInKB) => Math.round(byteInKB / 1000).toLocaleString();

	getProgressColor = (used, limit) => {
		const percentage = (used / limit) * 100;
		if (percentage >= 90) return 'danger';
		if (percentage >= 75) return 'warning';
		return 'success';
	}

	afterSubmit = () => {
		window.location.reload();
	}

	subscribeToCloud = async () => {
		confirmAlert({
			title: "Confirm FFLBoss Cloud Subscription",
			message: 'Subscribe to FFLBoss Cloud for $25.00/month?',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						this.setState({loading: true});
						let cloudModel = new API.BuildClass(Types.Locations_Modules._name, API.RequestType.CREATE);
						cloudModel.parent = this.props.rootState.locations[0].binary_id + '-' + this.props.rootState.locations[0].pkey;
						cloudModel.object.module = 9;
						await cloudModel.submit(null, API.RequestType.CREATE);
						// this.setState({key: Math.random()})
						this.props.history.push('/');
						this.props.history.push('/accounts#cloud');
						this.setState({loading: false});
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	form = () => {
		/** @type {Accounts_Customizations_Properties} properties */
		let properties = this.model.properties;
		/** @type {Accounts_Customizations_Object} object */
		let object = this.state;
		return (
			<>
				<Card>
					<CardContent style={{paddingBottom: 0}}>
						<div className={"row"}>
							<div className={"col-md"}>
								<h4 className="section-title">Storage Usage by Location</h4>
								{this.props.rootState.hasCloudModule ?
									<div style={{maxHeight: '500px', overflowY: 'auto'}} className="pr-2">
										{Object.keys(object.locations).map(locationId => {
											const locationData = object.locations[locationId];
											let totalLimit = parseInt(locationData.data_usage_limit);
											let totalUsed = parseInt((locationData.forms || 0)) + parseInt((locationData.images || 0)) + parseInt((locationData.uploaded || 0));
											const free = totalLimit - totalUsed;
											const categories = [
												{key: 'forms', label: 'Forms', icon: 'fa-file-text-o', value: locationData.forms || 0},
												{key: 'images', label: 'Images', icon: 'fa-image', value: locationData.images || 0},
												{key: 'uploaded', label: 'Uploaded Files', icon: 'fa-upload', value: locationData.uploaded || 0},
												{key: 'free', label: 'Free Space', icon: 'fa-hdd-o', value: free}
											];

											const getPercentage = (value) => {
												return totalLimit > 0 ? ((value / totalLimit) * 100).toFixed(2) : '0.00';
											};

											return (
												<Card key={locationId} className="mb-3">
													<CardContent>
														<h5 className="mb-3">{locationData.display_name}</h5>

														<div className="mb-3">
															<div className="d-flex justify-content-between mb-1">
																<span><strong>Total Usage</strong></span>
																<span>{this.convertByteSize(totalUsed)}MB of {this.convertByteSize(totalLimit)}MB
																</span>
															</div>
															<Progress
																value={totalUsed}
																max={totalLimit}
																color={this.getProgressColor(totalUsed, totalLimit)}
																style={{height: '20px'}}
															>
																<div style={{
																	position: 'absolute',
																	left: '50%',
																	transform: 'translate(-50%)',
																	color: 'black',
																	fontSize: '12px'
																}}>
																	{((totalUsed / totalLimit) * 100).toFixed(2)}%
																</div>
															</Progress>
														</div>

														<div className="row">
															{categories.map((category) => {
																const percentage = getPercentage(category.value);
																return (
																	<div key={category.key} className="col-6 mb-2">
																		<div className="d-flex align-items-center mb-1">
																			<i className={`fa ${category.icon} mr-2`}
																			   style={{fontSize: '1rem', width: '16px'}}></i>
																			<span style={{fontSize: '14px'}}>{category.label}</span>
																		</div>
																		<div className="d-flex justify-content-between" style={{fontSize: '12px'}}>
																			<span>{this.convertByteSize(category.value)}MB</span>
																			<span>{percentage}%</span>
																		</div>
																		<Progress
																			value={category.value}
																			max={totalLimit}
																			color={category.key === 'free' ? 'info' : this.getProgressColor(category.value, totalLimit)}
																			style={{height: '8px'}}
																		/>
																	</div>
																);
															})}
														</div>
													</CardContent>
												</Card>
											);
										})}
									</div>
									: <div className="form-group">
										Subscribe to the FFLBoss Cloud to access location data storage breakdown and more!
										<Button color="primary" onClick={this.subscribeToCloud} style={{float: 'right', marginBottom: '15px'}}>Subscribe to Cloud</Button>
									</div>}
							</div>

							<div className={"col-md"}>
								{this.props.rootState.hasCloudModule &&
									<div>
										<h4 className="section-title">Download 4473's</h4>
										<div className="form-group">
											Download all 4473 pdf's associated with this account into a zip file.
										</div>
										<div className="form-group">
											<Button color="warning" onClick={this.downloadPDFs}>PDF Download</Button>
										</div>
									</div>}

							</div>
						</div>

						{/* Storage usage breakdown is now inline above */}

						<UniversalModalOverride
							name={"Signature"}
							locations={this.props.locations}
							states={this.props.states}
							kiosks={this.props.kiosks}
							history={this.props.history}
							object={Objects.AccountSign}
							toggle={object.accountSign}
							size={"lg"}
							afterSave={this.pendingComplete}
							reportClose={this.reportClose('accountSign')}
						/>

					</CardContent>
				</Card>
			</>
		)
	}

	render() {
		return (
			<Card style={{overflow: 'visible'}}>
				<CardContent style={{paddingBottom: 0}}>
					{this.form()}
					<hr style={{marginBottom: 0}}/>
				</CardContent>

				<CardActions style={{justifyContent: 'end', padding: '14px'}}>
					<Button color="primary" onClick={this.handleSubmit}>Save</Button>
				</CardActions>
				<Framework.Elements.LoadingSpinner isLoading={this.state.loading}/>
			</Card>
		)
	}
}

export default Framework.Components.withRootState(AccountCloud);